/* eslint-disable no-console */
/**
 * Gets the CLinker value for cross-domain tracking
 *
 * Priority:
 * 1. From Common Data Layer (coxAutoDataLayer.getState().user.cLinker)
 * 2. From cookie (_cl)
 * 3. Return null if both are undefined (user opted out of tracking)
 *
 * @returns {string|null} CLinker value or null if tracking is disabled
 */
const getCLinkerValue = () => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
        return null;
    }

    // First priority: Try to get from Common Data Layer
    try {
        if (window.coxAutoDataLayer && typeof window.coxAutoDataLayer.getState === 'function') {
            const cLinker = window.coxAutoDataLayer.getState()?.user?.cLinker;
            if (cLinker !== undefined) {
                return cLinker;
            }
        }
    } catch (error) {
        console.error('getCLinkerValue: Error accessing Common Data Layer:', error);
        // Silently ignore CDL errors and try cookie fallback
    }

    // Second priority: Try to get from cookie
    try {
        const cookieValue = document.cookie
            .split('; ')
            .find((row) => row.startsWith('_cl='))
            ?.split('=')[1];

        if (cookieValue !== undefined) {
            return cookieValue;
        }
    } catch (error) {
        console.error('getCLinkerValue: Error accessing cookie:', error);
        // Silently ignore cookie errors
    }

    // Return null if both CDL and cookie are undefined (user opted out)
    return null;
};

export default getCLinkerValue;
